import { Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { linkTriggerExamLoad, linkTriggerEvaluationLoad } from '../Consts';
import './Home.css';


const Home = () => {

    return (
        <>
            <h5 className="mt-4">Aktuell sind keine Klassenarbeiten geöffnet.</h5>
            <h6>Was möchten Sie tun?</h6>

            <Row xs={1} md={2} className="g-4 d-flex align-items-stretch mt-3">
                <Col className="d-flex">
                    <Card bg="light" text="dark" border="dark">
                        <Card.Header as="h5">Klassenarbeiten öffnen</Card.Header>
                        <Card.Body>
                            {/* <Card.Title>Klassenarbeiten verwalten</Card.Title> */}
                            <Card.Text>
                                Es können lokal gespeicherte Klassenarbeiten aus dem Erfassungswerkzeug sowie Exporte
                                von Klassenarbeiten aus <code>moodle</code> in das Werkzeug geladen werden.
                            </Card.Text>
                        </Card.Body>
                        <Card.Footer className="d-flex justify-content-center">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                as={Link}
                                to={linkTriggerExamLoad}
                                className="button-hover-white"
                            >
                                Klassenarbeiten öffnen
                            </Button>
                        </Card.Footer>
                    </Card>
                </Col>
                <Col className="d-flex">
                    <Card bg="light" text="dark" border="dark">
                        {/* <Card.Img variant="top" src="holder.js/100px160" /> */}
                        <Card.Header as="h5">Analysestand öffnen</Card.Header>

                        <Card.Body>
                            {/* <Card.Title>Auswertungsstand laden</Card.Title> */}
                            <Card.Text>
                                Wenn Sie aus dieser Anwendung heraus einen Analysestand lokal gespeichert haben, können Sie diesen
                                hier öffnen.
                            </Card.Text>
                        </Card.Body>
                        <Card.Footer className="d-flex justify-content-center">
                            <Button
                                variant="outline-primary"
                                size="sm"
                                as={Link}
                                to={linkTriggerEvaluationLoad}
                                className="button-hover-white"
                            >
                                Analysestand öffnen
                            </Button>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default Home;